if (!customElements.get('article-notifications')) {
  customElements.define('article-notifications', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-notification-open]');
      if (!this.dialog || !this.trigger) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.items = Array.from(this.dialog.querySelectorAll('[data-notification-article]'));
      this.storageKey = `theme-article-notifications:${this.dataset.shop}`;
      this.read = new Set();
      this.loadRead();
      document.body.append(this.dialog);
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-notification-open]');
        if (trigger?.getAttribute('aria-controls') === this.dialog.id) this.open(trigger);
      }, options);
      this.dialog.querySelector('[data-notification-close]').addEventListener('click', () => this.dialog.close(), options);
      this.readAll = this.dialog.querySelector('[data-notification-read-all]');
      this.readAll.addEventListener('click', () => {
        this.items.forEach((item) => this.read.add(this.itemKey(item)));
        this.saveRead();
      }, options);
      this.items.forEach((item) => item.addEventListener('click', () => {
        this.read.add(this.itemKey(item));
        this.saveRead();
      }, options));
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        this.getTriggers().forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
        if (!document.querySelector('.article-notifications__dialog[open]')) document.body.classList.remove('article-notifications-open');
        if (this.isConnected) {
          const trigger = this.activeTrigger?.isConnected ? this.activeTrigger : this.trigger;
          if (this.activeDrawer?.mainDetailsToggle?.open && typeof trapFocus === 'function') {
            trapFocus(this.activeDrawer.mainDetailsToggle, trigger);
          } else {
            trigger.focus({ preventScroll: true });
          }
        }
      }, options);
      window.addEventListener('storage', (event) => {
        if (event.key === this.storageKey || event.key === null) { this.loadRead(); this.update(); }
      }, options);
      document.addEventListener('article-notifications:read', (event) => {
        if (event.detail.key !== this.storageKey) return;
        this.read = new Set(event.detail.ids);
        this.update();
      }, options);
      this.update();
    }
    itemKey(item) { return `${item.dataset.notificationArticle}:${item.dataset.published}`; }
    getTriggers() {
      return Array.from(document.querySelectorAll('[data-notification-open]')).filter((trigger) => trigger.getAttribute('aria-controls') === this.dialog.id);
    }
    loadRead() {
      try {
        const stored = JSON.parse(localStorage.getItem(this.storageKey) || '[]');
        this.read = new Set(Array.isArray(stored) ? stored.filter((id) => typeof id === 'string') : []);
      } catch (_) { this.read = new Set(); }
    }
    saveRead() {
      const ids = Array.from(this.read).slice(-500);
      try { localStorage.setItem(this.storageKey, JSON.stringify(ids)); } catch (_) {}
      this.update();
      document.dispatchEvent(new CustomEvent('article-notifications:read', { detail: { key: this.storageKey, ids } }));
    }
    update() {
      let count = 0;
      this.items.forEach((item) => {
        const unread = !this.read.has(this.itemKey(item));
        item.querySelector('[data-notification-new]').hidden = !unread;
        if (unread) count++;
      });
      this.getTriggers().forEach((trigger) => {
        const badge = trigger.querySelector('[data-notification-count]');
        badge.hidden = count === 0;
        badge.textContent = String(count);
        trigger.querySelector('[data-notification-status]').textContent = this.dataset.unreadLabel.replace('[count]', String(count));
      });
      this.readAll.disabled = count === 0;
    }
    open(trigger = this.trigger) {
      document.querySelectorAll('.article-notifications__dialog[open]').forEach((dialog) => {
        if (dialog !== this.dialog) dialog.close();
      });
      this.activeTrigger = trigger;
      this.activeDrawer = trigger.closest('header-drawer');
      if (this.activeDrawer?.mainDetailsToggle?.open && typeof removeTrapFocus === 'function') removeTrapFocus();
      if (!this.dialog.open) this.dialog.showModal();
      this.getTriggers().forEach((entry) => entry.setAttribute('aria-expanded', 'true'));
      document.body.classList.add('article-notifications-open');
    }
    disconnectedCallback() {
      this.controller?.abort();
      if (this.dialog?.open) this.dialog.close();
      this.dialog?.remove();
      if (!document.querySelector('.article-notifications__dialog[open]')) document.body.classList.remove('article-notifications-open');
      this.controller = null;
    }
  });
}
